module.exports = __webpack_public_path__ + "img/envonriment_en.d1a666f0.png";